import { useEffect } from 'react';

export default function Docs() {
  useEffect(() => {
    window.location.replace('https://docs.cybernate.ai');
  }, []);
  return null;
}
